import { AxiosResponse } from 'axios'
import request from 'src/utils/request'
import { OFFERS_EXPLORER_SERVICE_URI } from './constants'

export const getPoliciesApi = (slug): Promise<AxiosResponse> => request.get(`strapi/policies/${slug}`)

export const getLandbotApi = (code): Promise<AxiosResponse> => request.get(`strapi/landbots/${code}`)

export const getBlogPosts = (): Promise<AxiosResponse> =>
  request.get('https://blog.carplanner.com/rss.xml', { responseType: 'text' })

export const getChiSiamoApi = (): Promise<AxiosResponse> => request.get('strapi/chi-siamo')

export const getPressApi = (): Promise<AxiosResponse> => request.get('strapi/press-items')

export const searchModelsApi = (path, term): Promise<AxiosResponse<any>> =>
  request.post(`${OFFERS_EXPLORER_SERVICE_URI}/${path}`, { term })
